import { Chart } from '@/components/Chart';
import type { TrendPoint } from '@/types/admin-settings';
import { formatChartTooltipTitleByGroupBy } from '@/utils/chart-periods';
import { formatDayTick } from './utils';

const CHART_HEIGHT = 180;

interface TrendChartCardProps {
    title: string;
    data: TrendPoint[];
    tooltipLabel: string;
    strokeColor: string;
    fillColor: string;
    interval: number | 'preserveStartEnd';
}

export function TrendChartCard({
    title,
    data,
    tooltipLabel,
    strokeColor,
    fillColor,
    interval,
}: TrendChartCardProps) {
    return (
        <div className="border border-grey-600 rounded-[10px] p-4 flex flex-col gap-3">
            <span className="text-sm text-grey-200">{title}</span>
            <Chart
                data={data}
                height={CHART_HEIGHT}
                strokeColor={strokeColor}
                fillColor={fillColor}
                tooltipLabel={tooltipLabel}
                tooltipTitleFormatter={(value) =>
                    formatChartTooltipTitleByGroupBy(value, 'daily')
                }
                xAxisTickFormatter={formatDayTick}
                xAxisInterval={interval}
            />
        </div>
    );
}
